import { CommonModule } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import {
  AdjuntoCliente,
  InformacionTerceroAdicionales,
  InformacionTerceroDTO,
} from "../../../../_models/perfil-cliente/informacionTercero";
import { ListasRestrictivasRespuesta } from "../../../../_models/perfil-cliente/listasRestrictivas";
import { NotaInterna } from "../../../../_models/perfil-cliente/notaInterna";

@Component({
  selector: "app-perfil-crezcamos-seccion",
  templateUrl: "./perfil-crezcamos-seccion.component.html",
  styleUrls: ["./perfil-crezcamos-seccion.component.scss"],
})
export class PerfilCrezcamosSeccionComponent implements OnInit {
  @Input() informacionPerfil: any;
  banderaCargando = true;
  informacionTercero: InformacionTerceroDTO;
  informacionTerceroAdicional: InformacionTerceroAdicionales;
  listasRestrictivas: ListasRestrictivasRespuesta;
  informacionNotaInterna: NotaInterna;
  listadoAdjuntos: AdjuntoCliente[] = [];
  acceso: boolean = false;

  constructor() // private adjService: AdjuntosService
  {}

  async ngOnInit() {
    if (this.informacionPerfil && this.informacionPerfil.secciones) {
      this.acceso = this.tieneAcceso(this.informacionPerfil.secciones);
    } else {
      this.acceso = false;
      this.banderaCargando = false;
      return
    }

    this.informacionTercero =
      this.informacionPerfil && this.informacionPerfil.informacionTerceroDTO
        ? this.informacionPerfil.informacionTerceroDTO
        : null;
    this.listasRestrictivas =
      this.informacionPerfil &&
      this.informacionPerfil.listasRestrictivasRespuesta
        ? this.informacionPerfil.listasRestrictivasRespuesta
        : null;
    this.informacionTerceroAdicional =
      this.informacionPerfil &&
      this.informacionPerfil.informacionTerceroAdicionalesDTO
        ? this.informacionPerfil.informacionTerceroAdicionalesDTO
        : null;
    this.informacionNotaInterna =
      this.informacionPerfil &&
      this.informacionPerfil.tercerosNotaInternaRespuesta
        ? this.informacionPerfil.tercerosNotaInternaRespuesta
        : null;

    console.log(this.informacionTercero);
    console.log(this.listasRestrictivas);
    console.log(this.informacionTerceroAdicional);
    console.log(this.informacionNotaInterna);

    this.obtenerAdjuntos();

    this.banderaCargando = false;
  }

  tieneAcceso(array) {
    return array.includes("PERCRZ");
  }

  obtenerAdjuntos() {
    this.listadoAdjuntos = [];

    if (this.informacionTercero && this.informacionTercero.idAdjunto) {
      this.listadoAdjuntos.push({
        idAdjunto: this.informacionTercero.idAdjunto,
        direccion: null,
        fotoCliente: true,
        nombre: null
      });
    }

    if (this.informacionTercero && this.informacionTercero.fotosUPList) {
      this.listadoAdjuntos.push(
        ...this.informacionTercero.fotosUPList.map((foto) => ({
          idAdjunto: foto.idAdjunto,
          direccion: foto.direccionUP,
          fotoCliente: false,
          nombre: foto.nombre
        }))
      );
    }
  }
}
